<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <register-title class="form__title">{{
        $t("identification")
      }}</register-title>
      <div class="select-container">
        <label class="label">{{ $t("citizenship") }}</label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.citizenship"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <div class="select-container">
        <register-input
          v-model="form.birth_date"
          componentID="validity-date"
          inputType="date"
          :label="$t('birthday')"
          :maxDate="new Date()"
          :isRequired="true"
          class="form__input"
        />
      </div>
      <register-input
        v-model="form.birth_place"
        componentID="series"
        inputType="text"
        :label="$t('birth place')"
        :isRequired="true"
        class="form__input"
      />
      <div class="select-container">
        <label class="label">{{ $t("document type") }}</label>
        <exp-select
          :options="registrationDocumentTypesList"
          v-model="form.document_type"
          @change="(form.document_number = ''), (form.document_serial = '')"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <!--------------------------------------------------------   DOC SERIES   ----->
      <register-input
        v-model="form.document_serial"
        componentID="series"
        inputType="text"
        :label="$t('series')"
        :isRequired="false"
        class="form__input"
      />
      <!--------------------------------------------------------   DOC PASSPORT NUMBER   ----->
      <label class="label">
        {{ $t("id document number") }}
        <span class="red">*</span>
      </label>
      <input
        type="text"
        class="input form__input wide"
        :placeholder="$t('id document number')"
        required
        v-model="form.document_number"
        @keyup="formatDocNumber"
        @blur="formatDocNumber"
      />
      <!--------------------------------------------------------   ISSUE DATE (START)    ----->
      <register-input
        v-model="form.document_issued_at"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        :label="$t('issue date')"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   ISSUE DATE (END)   ----->
      <register-input
        v-model="form.document_valid_till"
        componentID="validity-date"
        inputType="date"
        :label="$t('expires')"
        :minDate="new Date()"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        v-model="form.document_issuer"
        componentID="issuing-authority"
        inputType="text"
        label="Кем выдано"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   NOT CITIZEN   ----->

      <div v-if="form.citizenship != 92">
        <hr class="horizontal-line" />
        <label class="label" style="text-align: center">
          {{ $t("visa migration card") }}
        </label>
        <exp-select
          :options="visa_types"
          v-model="form.migration_document_type"
          :title="$t('choose country')"
        ></exp-select>
        <!-- VISA DOCS -->
        <div v-if="form.migration_document_type == 1">
          <register-input
            v-model="form.visa_number"
            componentID="visa-number"
            :label="$t('visa number')"
            inputType="text"
            :inputPlaceholder="$t('visa number')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.visa_issued_at"
            inputType="date"
            componentID="issue-date"
            :label="$t('document issuing date')"
            :maxDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.visa_valid_till"
            inputType="date"
            componentID="validity-date"
            :label="$t('document expires')"
            :minDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
        </div>
        <!-- Migration Docs -->
        <div v-else>
          <register-input
            v-model="form.migration_card_number"
            componentID="migration-card-number"
            :label="$t('migration card number')"
            inputType="text"
            :inputPlaceholder="$t('migration card number')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.migration_card_issued_at"
            inputType="date"
            componentID="issue-date"
            :label="$t('document issuing date')"
            :maxDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.migration_card_valid_till"
            inputType="date"
            componentID="validity-date"
            :label="$t('document expires')"
            :minDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
        </div>
      </div>
      <button class="button filled form__button">{{ $t("confirm") }}</button>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      form: {
        citizenship: null,
        birth_date: null,
        birth_place: null,
        document_issued_at: null,
        document_valid_till: null,
        document_type: null,
        document_serial: null,
        document_number: null,
        document_issuer: null,
        visa_number: null,
        visa_issued_at: null,
        visa_valid_till: null,
        // MIGRATION citizens
        migration_document_type: null,
        migration_card_number: null,
        migration_card_issued_at: null,
        migration_card_valid_till: null
      },
      form_dates: [
        "birth_date",
        "document_issued_at",
        "document_valid_till",
        "migration_card_issued_at",
        "migration_card_valid_till",
        "visa_issued_at",
        "visa_valid_till"
      ]
    };
  },
  mixins: [regFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    formatDocNumber() {
      // console.log(this.isKazDoc(this.form.document_type));
      if (this.isKazDoc(this.form.document_type)) {
        this.form.document_number = this.form.document_number.replace(
          /\D/g,
          ""
        );
        this.form.document_number = this.form.document_number.substr(0, 9);
      }
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        this.form_dates.forEach(date => {
          this.form[date] = this.dateFormat(this.form[date]);
        });
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "work-info" });
    },
    saveData() {
      let url = `user/profile`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      FhsAxios.post(url, form).then(res => {
        // console.log(res);
        // console.log(res.data);
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
